/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function IntegrationRetryStatisticsController($mdDialog, integrationService, entityId, entityType) {
    var vm = this;
    vm.rows = [];
    vm.loading = true;
    vm.cancel = cancel;
    vm.converterTotal = 0;
    vm.publishTotal = 0;
    vm.isMqttV2 = entityType === 'MQTT_V2';
    vm.queueStats = null;

    integrationService.getRetryStatistics(entityId).then(
        (data) => {
            vm.rows = data;
            vm.converterTotal = data.filter(r => r.stage === 'converter').reduce((sum, r) => sum + r.count, 0);
            vm.publishTotal = data.filter(r => r.stage === 'publish').reduce((sum, r) => sum + r.count, 0);
            vm.loading = false;
        },
        () => {
            vm.loading = false;
        }
    );

    if (vm.isMqttV2) {
        integrationService.getQueueStatistics(entityId).then(
            (data) => {
                vm.queueStats = data;
            },
            () => {}
        );
    }

    function cancel() {
        $mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./src/app/integration/integration-retry-statistics.controller.js